<template>
  <div class="layout-menu-dialog">
    <div class="title">
      <div class="title-text">已选常用模块({{ tableData.length }})</div>
      <div class="title-tips">拖动可调整排序或拖动到对应的分组</div>
    </div>
    <div class="layout-menu-dialog-sider">
      <div class="tree-box">
        <el-autocomplete
          ref="searchMenu"
          class="search-input"
          v-model="searchKey"
          placeholder="搜索模块"
          popper-class="kye-popper-auto"
          value-key="$title"
          clearable
          :trigger-on-focus="false"
          :fetch-suggestions="searchMenu"
          @select="selectMenu">
          <i slot="prefix" class="el-input__icon el-icon-search" />
        </el-autocomplete>
        <div class="tree-box-content kye-scrollbar">
          <Tree :data="rankMenus"
            keyField="menuId"
            labelField="menuName"
            childrenField="children"
            :group="false"
            ref="rankTree"
            :renderContent="renderRankTreeContent"
            @check="onRankTreeCheck"
            class="rank-tree" />
          <Tree :data="menuTree" keyField="id" childrenField="children" ref="tree" @check="onCheckClick" />
        </div>
      </div>
    </div>
    <div class="kye-dialog-body" >
      <draggable
        ref="draggable"
        class="drag-box kye-scrollbar"
        :list="tableData"
        v-loading="loading"
        v-bind="dragOptions">
        <div v-for="(item, index) of tableData" class="drag-box-item" :key="item.menuCode" :title="item.title && item.title.length > 6 ? item.title : ''">
          <img :src="menuIconMap[item.menuCode] || emptyIcon" />
          <span>{{ item.title }}</span>
          <div class="drag-box-item-close" @click="onDelete(item, index)">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </draggable>
    </div>
    <div class="el-dialog__footer">
      <el-button type="primary" hotkey="ctrl+s" @click="onSave" class="save-button">保存(S)</el-button>
      <el-button @click="close" class="cancel-button">取消</el-button>
    </div>
  </div>
</template>

<script>
  import { cloneDeep, uniqBy } from 'lodash'
  import Draggable from 'vuedraggable'
  import Tree from '@/layout/components/tree'
  import { getMenuIcon } from './menuIcon'
  import emptyIcon from '@/layout/components/images/empty-icon.png'
  import NoAuthNode from './no-auth-node.vue'
  import RankNode from './rank-node.vue'
  export default {
    name: 'module-manage',
    components: { Draggable, Tree },
    props: {
      menuGroup: Object
    },
    data () {
      return {
        searchKey: '',
        tableData: [],
        loading: false,
        dragOptions: {
          draggable: '.drag-box-item',
          handle: '.drag-box-item',
          animation: 150,
          ghostClass: 'kye-ghost'
        },
        menuIconMap: {},
        emptyIcon,
        rankMenus: [
          {
            menuName: '为你推荐',
            menuId: 'rank',
            children: []
          }
        ],
        rankMenuKeysSet: new Set()
      }
    },
    computed: {
      menus () {
        return this.$store.getters.menus
      },
      menuTree () {
        let arr = this.$store.getters.menus.menuTree || []
        return arr.slice(1).map((item, index) => {
          item.id = `sub_${index}`
          return item
        })
      },
      urls () {
        return this.tableData.map(v => v.url)
      },
    },
    created () {
      this.onOpen()
    },
    methods: {
      renderRankTreeContent (h, { node, data }) {
        if (node.level === 0) {
          return <RankNode />
        }
        if (data.disabled) {
          return <NoAuthNode data={data} />
        }
        return (
          <span>{`${data.menuName}`}</span>
        )
      },
      searchMenu (val, cb) {
        const res = []
        if (val) {
          Object.values(this.menus).forEach(v => {
            let title = v.$title
            if (title && title.indexOf(val) > -1) {
              res.push(v)
            }
          })
        }
        cb(res)
        // 自动选择第一行
        this.$nextTick(_ => {
          res.length && this.$refs['searchMenu'].highlight && this.$refs['searchMenu'].highlight(0)
        })
      },
      selectMenu (val) {
        if (this.tableData.some(v => v.url === val.menuCode)) {
          this.$message.warning('此模块已存在')
          return false
        }
        this.searchKey = ''
        const newTag = this.buildTag(val.menuCode)
        this.tableData.unshift(newTag)
        this.updateTreeChecked()
      },
      onDelete (item, index) {
        this.tableData.splice(index, 1)
        this.updateTreeChecked()
      },
      async onSave () {
        let itemList = this.tableData.map((v, i) => {
          return { ...v, displaySequence: i + 1, icon: '', moduleType: '10', ...this.menuGroup }
        })
        // 判断是否是新增的
        const isAdd = val => this.cacheData.findIndex(item => item.url === val.url) === -1
        const addList = itemList.filter(item => isAdd(item))
        itemList = itemList.filter(item => !isAdd(item))
        const params = { moduleType: '10', ...this.menuGroup, itemList, addList }
        await this.$http('system.homeIndex.save', params)
        this.$emit('close')
        this.$emit('update')
      },
      close () {
        this.$emit('close')
      },
      async onOpen () {
        try {
           // 每次打开都获取最新的收藏模块
          this.loading = true
          this.menuIconMap = await getMenuIcon()
          await this.initRankMenus()
          await this.getLinks()
          this.updateTreeChecked()
          this.loading = false
        } catch (error) {
          this.loading = false
        }
      },
      async initRankMenus() {
        const {topMenuAccessCountList = [], topMenuUserCountList = []} = await this.$http('mcs.menu.access.user.same.position.ranking', {employeeNumber: this.$store.state.user.employeeNumber}, {appkey: 10124})
        const menus = this.menus
        const list = uniqBy([...topMenuAccessCountList, ...topMenuUserCountList], 'menuId')
        .map(item => {
          const disabled = !menus[item.menuCode]
          return {
            ...item,
            disabled
          }
        })
        .filter(item => !item.disabled)
        const hasAuthMenus = list.filter(item => this.menus[item.menuCode])

        if (list.length) {
          this.rankMenus = [{
            menuName: '为你推荐',
            menuId: 'rank',
            children: list
          }]
        } else {
          this.rankMenus = []
        }
        this.rankMenuKeysSet = new Set(hasAuthMenus.map(item => item.menuId))
      },
      async getLinks () {
        try {
          const res = await this.$http('system.homeIndex.list', { moduleType: '10', ...this.menuGroup }, false) || []
          const tableData = res.map(item => this.buildTag(item.url)).filter(Boolean)
          this.tableData = tableData
          this.cacheData = cloneDeep(tableData)
        } catch (e) {
          console.error(e)
        }
      },
      onRankTreeCheck () {
        const menus = this.menus
        const rankMenuIds = this.rankMenuKeysSet
        const currentRankCheckedKeys = this.tableData
          .map(item => menus[item.url] && menus[item.url].id)
          .filter(id => id && rankMenuIds.has(id))
        const leafMenus = this.$refs.rankTree.getCheckedNodes('child').filter(Boolean).map(item => item.rawNode)
        if (leafMenus.length < currentRankCheckedKeys.length) {
          const newCheckedIds = new Set(leafMenus.map(item => item.menuId))
          this.tableData = this.tableData.filter(item => {
            const menu = menus[item.url]
            if (!menu || !rankMenuIds.has(menu.id)) return true
            return newCheckedIds.has(menu.id)
          })
        } else {
          const addTags = leafMenus
            .filter(item => !currentRankCheckedKeys.includes(item.menuId))
            .map(item => this.buildTag(item.menuCode))
            .filter(Boolean)
          this.tableData.unshift(...addTags)
        }
        this.updateTreeChecked()
      },
      handleRankCheckAll (checked) {
        if (!this.rankMenus.length) return
        const menus = this.menus
        const rankMenuIds = this.rankMenuKeysSet
        if (checked) {
          const existingIds = new Set(
            this.tableData.map(item => menus[item.url] && menus[item.url].id).filter(Boolean)
          )
          const addTags = this.rankMenus
            .filter(item => !existingIds.has(item.menuId))
            .map(item => this.buildTag(item.menuCode))
            .filter(Boolean)
          this.tableData.unshift(...addTags)
        } else {
          this.tableData = this.tableData.filter(item => {
            const menu = menus[item.url]
            return !menu || !rankMenuIds.has(menu.id)
          })
        }
        this.updateTreeChecked()
      },
      onCheckClick () {
        const menus = this.menus
        const currentCheckedKeys = this.tableData.map(item => {
          return menus[item.url].id
        })
        // 获取叶子节点
        const leafMenus = this.$refs.tree.getCheckedNodes('child').filter(Boolean).map(item => item.rawNode)
        if (leafMenus.length < currentCheckedKeys.length) {
          // 删除
          const newCurrentUrls = leafMenus.map(item => item.menuCode)

          this.tableData = this.tableData.filter(item => newCurrentUrls.includes(item.url))
        } else {
          // 新增
          const addTags = leafMenus.filter(item => !currentCheckedKeys.includes(item.id)).map(item => this.buildTag(item.menuCode))
          this.tableData.unshift(...addTags)
        }
        this.updateTreeChecked()
      },
      // 更新树的选中状态
      updateTreeChecked () {
        const menus = this.$store.state.menus
        const checkedKeys = this.tableData.map(item => {
          return menus[item.url].id
        })
        const rankCheckedKeys = checkedKeys.filter(key => this.rankMenuKeysSet.has(key))
        this.$refs.tree.setCheckedKeys(checkedKeys)
        this.$refs.rankTree.setCheckedKeys(rankCheckedKeys)
      },
      buildTag (menuCode) {
        const menu = this.menus[menuCode]
        if (!menu) return null
        return {
          icon: '',
          menuCode: menu.menuCode,
          title: menu.title,
          url: menu.menuCode
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-menu-dialog {
  background: #ffffff;
  .title {
    position: absolute;
    left: 223px;
    display: flex;
    align-items: center;
    top: 16px;
    &-text {
      color: var(--g-theme-color-text);
      font-family: "Microsoft YaHei UI";
      font-style: Bold;
      font-size: 16px;
      font-weight: 700;
      line-height: 22px;
      letter-spacing: 0px;
      text-align: left;
    }
    &-tips {
      color: #68607B;
      font-family: "Microsoft YaHei";
      font-style: Regular;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0px;
      margin-left: 12px;
      text-align: left;
    }
  }
  .kye-dialog-body {
    padding-bottom: 0px;
  }
  .el-dialog__footer {
    padding: 16px;
  }
  .layout-menu-dialog-sider {
    width: 200px;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background: #F9FAFD;
    padding: 16px 0 8px;
    border-radius: 16px 0 0 16px !important;
    .tree-box {
      display: flex;
      flex-direction: column;
      height: 100%;
      .tree-box-content {
        flex: 1;
        overflow-x: hidden;
        overflow-y: auto;
        scrollbar-gutter: stable;
        min-height: 0;
        padding: 0px 12px 8px 16px;
        margin-top: 12px;
        background: transparent;
        border-radius: 16px 0 0 16px !important;
        /deep/ .rank-tree {
          margin-bottom: 12px;
        }
        /deep/ .rank-tree + .layout-tree {
          margin-top: 6px;
          padding-top: 12px;
          border-top: 1px solid rgba(224, 223, 239, 0.7);
        }
      }
    }
    .search-input {
      width: calc(100% - 32px);
      margin: 0 16px;
      /deep/ .el-input__inner {
        border-radius: 8px;
        border: 1px solid #E0DFEF;
        background-color: #ffffff;
        padding-left: 28px !important;
      }
    }
  }
   .kye-dialog-body {
    display: flex;
    max-height: calc(70vh - 45px);
    padding-left: 212px;
    background: #ffffff;
    .tips {
      color: #999999;
      font-size: 12px;
    }
    .tree-box {
      border: 1px solid #c1bfc7;
      border-radius: 2px;
      padding: 12px;
    }
    .tree-content {
      height: calc(70vh - 180px);
      overflow-y: auto;
      margin-top: 12px;
    }
    .drag-box {
      height: calc(70vh - 115px);
      overflow-y: auto;
      border-radius: 2px;
      padding: 0 12px 12px;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      flex: 1;
      min-width: 0;
      gap: 12px;
      user-select: none;
      .drag-box-item {
        cursor: move;
        width: 214px;
        height: 56px;
        box-sizing: border-box;
        padding: 0 12px;
        display: flex;
        align-items: center;
        border-radius: 8px;
        background: rgba(249, 249, 254, 1);
        img {
          display: block;
          width: 48px;
          height: 48px;
          margin-right: 4px;
        }
        span {
          color: #453C5A;
          font-family: "Microsoft YaHei";
          font-style: Regular;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0px;
          margin-left: 4px;
          text-align: left;
          flex: 1;
          min-width: 0;
        }
        .drag-box-item-close {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: transparent;
          cursor: pointer;
          &:hover {
            background: rgba(109, 46, 248, 0.1);
          }
        }
        i {
          font-size: 14px;
          color: #68607B; // theme
          cursor: pointer;
        }
      }
    }
    .menu-tree-node__label {
      color: #ff9300;
    }

    .drag-box .el-tag .el-icon-close {
      // position: absolute;
      // top: 9px;
      // right: 4px;
      color: #ABABB3;
      // height: 12px;
      // width: 12px;
      // line-height: 12px;
      // transform: none;
      // &:hover {
      //   color: #ffffff;
      //   background-color: #979797;
      // }
    }
  }
  .save-button {
    width: 66px;
    height: 32px;
    background-color: #6D2EF8;
    border-color: #6D2EF8;
    border-radius: 16px;
  }
  .cancel-button {
    width: 66px;
    height: 32px;
    /* 自动布局 */
    border-radius: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/add-menu-dialog.vue